// removed by extract-text-webpack-plugin
module.exports = {"wrapSliders":"_1LUvVMYWiIat77yU2dWB2h","slide":"_2cubmU1_IaDVLY3UtleO4Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Portfolio/PortfolioGallery/PortfolioGallery.scss
// module id = 1696
// module chunks = 0